import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import CategoryApi from 'apis/Category';
import Toaster from 'components/Toaster';

class CategorySelectField extends React.Component {
  constructor() {
    super();
    this.state = {
      removeSelected: true,
      isLoading: true,
      categories: [],
    };
  }

  componentDidMount() {
    this.fetchCategories();
  }

  fetchCategories() {
    CategoryApi.getAll()
      .then(({ data }) => {
        this.setState({ categories: data, isLoading: false });
      })
      .catch(() =>
        Toaster.getErrorMessage(
          'exclamation-triangle',
          'Failed to fetch categories'
        )
      );
  }

  render() {
    const { onChange, onBlur, value } = this.props;
    const { removeSelected, isLoading, categories } = this.state;
    const options = categories.map(category => {
      const array = { label: category.name, value: category.id };
      return array;
    });

    return (
      <div className="section">
        <Select
          multi
          isLoading={isLoading}
          options={options}
          placeholder="Select category"
          removeSelected={removeSelected}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          required
        />
      </div>
    );
  }
}
export default CategorySelectField;



// WEBPACK FOOTER //
// ./src/components/Form/categorySelectField.js